import { createReducer, PayloadAction } from '@reduxjs/toolkit';

import { toggleDarkMode } from '../actions/darkMode';

const initialState = {
    darkMode: null,
};

interface DarkModeState {
    darkMode: boolean | null;
}

export default createReducer(initialState, {
    [toggleDarkMode.type]: handleToggleDarkMode,
});

function handleToggleDarkMode(state: DarkModeState, action: PayloadAction<boolean>) {
    state.darkMode = action.payload;
}
